"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _timePicker = _interopRequireDefault(require("./timePicker"));
require("./styles.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TimePickerWrapper = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(TimePickerWrapper, _PureComponent);
  var _super = _createSuper(TimePickerWrapper);
  function TimePickerWrapper(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TimePickerWrapper);
    _this = _super.call(this, props);
    _this.state = {
      storeDate: props.value
    };
    _this.addHour = _this.addHour.bind((0, _assertThisInitialized2.default)(_this));
    _this.subtractHour = _this.subtractHour.bind((0, _assertThisInitialized2.default)(_this));
    _this.addMinute = _this.addMinute.bind((0, _assertThisInitialized2.default)(_this));
    _this.subtractMinute = _this.subtractMinute.bind((0, _assertThisInitialized2.default)(_this));
    _this.togglePeriod = _this.togglePeriod.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSelectedHour = _this.setSelectedHour.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSelectedMinute = _this.setSelectedMinute.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(TimePickerWrapper, [{
    key: "onChange",
    value: function onChange(newDate) {
      var _this2 = this;
      this.setState(function (prevState) {
        var date = (0, _momentTimezone.default)(prevState.storeDate).hour(newDate.hour()).minute(newDate.minute());
        _this2.props.onChange(date);
        return {
          storeDate: date
        };
      });
    }
  }, {
    key: "setSelectedMinute",
    value: function setSelectedMinute(newMinute) {
      this.onChange((0, _momentTimezone.default)(this.props.value).minute(newMinute));
    }
  }, {
    key: "setSelectedHour",
    value: function setSelectedHour(newHour) {
      this.onChange((0, _momentTimezone.default)(this.props.value).hour(newHour));
    }
  }, {
    key: "add",
    value: function add(value, unit) {
      this.onChange((0, _momentTimezone.default)(this.props.value).add(value, unit));
    }
  }, {
    key: "addHour",
    value: function addHour() {
      this.add(this.props.incrementsHour, 'hour');
    }
  }, {
    key: "subtractHour",
    value: function subtractHour() {
      this.add(-this.props.incrementsHour, 'hour');
    }
  }, {
    key: "addMinute",
    value: function addMinute() {
      this.add(this.props.incrementsMinute, 'minute');
    }
  }, {
    key: "subtractMinute",
    value: function subtractMinute() {
      this.add(-this.props.incrementsMinute, 'minute');
    }
  }, {
    key: "togglePeriod",
    value: function togglePeriod() {
      var value = this.props.value.hour() > 12 ? -12 : 12;
      this.add(value, 'hour');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        className = _this$props.className,
        actionBtn = _this$props.actionBtn,
        hoursDisplayed = _this$props.hoursDisplayed,
        minutesDisplayed = _this$props.minutesDisplayed;
      var selectedDate = this.state.storeDate;
      if ((0, _momentTimezone.default)(value).isValid() && typeof value !== 'string') {
        selectedDate = value;
      }
      if (!selectedDate) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(className, " time-picker-wrapper")
      }, /*#__PURE__*/_react.default.createElement(_timePicker.default, {
        selectedDate: selectedDate,
        addHour: this.addHour,
        subtractHour: this.subtractHour,
        addMinute: this.addMinute,
        subtractMinute: this.subtractMinute,
        togglePeriod: this.togglePeriod,
        setSelectedMinute: this.setSelectedMinute,
        setSelectedHour: this.setSelectedHour,
        hoursDisplayed: hoursDisplayed,
        minutesDisplayed: minutesDisplayed
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "action-time-wrapper"
      }, actionBtn));
    }
  }]);
  return TimePickerWrapper;
}(_react.PureComponent);
TimePickerWrapper.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_momentTimezone.default), _propTypes.default.string]),
  onChange: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  actionBtn: _propTypes.default.element.isRequired,
  incrementsMinute: _propTypes.default.number,
  incrementsHour: _propTypes.default.number,
  minutesDisplayed: _propTypes.default.bool,
  hoursDisplayed: _propTypes.default.bool
};
TimePickerWrapper.defaultProps = {
  value: null,
  className: '',
  incrementsMinute: 1,
  incrementsHour: 1,
  minutesDisplayed: true,
  hoursDisplayed: true
};
var _default = TimePickerWrapper;
exports.default = _default;